export class Translations {
    constructor(translationsobject) {

        translationsobject = typeof translationsobject !== 'undefined' ? translationsobject : {};
        var t = translationsobject;

        this.common = {
            Cancel: t.Cancel,
            Close: t.Close,
            Save: t.Save,
            Search: t.Search
        };

        this.internal = {
            ChangePasswordLink: t.ChangePasswordLink,
            ContactInfo: t.ContactInfo,
            ContactInfoLinkText: t.ContactInfoLinkText,
            CookiePolicy: t.CookiePolicy,
            CookiePolicyLinkText: t.CookiePolicyLinkText,
            CurrentPasswordHeading: t.CurrentPasswordHeading,
            DataProcessingDeclaration: t.DataProcessingDeclaration,
            DataProcessingDeclarationLinkText: t.DataProcessingDeclarationLinkText,
            ImpersonateUserLinkText: t.ImpersonateUserLinkText,
            ImpersonateUserModalHeading: t.ImpersonateUserModalHeading,
            ImpersonateUserSubmitButtonText: t.ImpersonateUserSubmitButtonText,
            ImpersonationActivatedModalButton: t.ImpersonationActivatedModalButton,
            ImpersonationActivatedModalHeading: t.ImpersonationActivatedModalHeading,
            ImpersonationActivatedModalText: t.ImpersonationActivatedModalText,
            ImpersonationSearchBoxHeading: t.ImpersonationSearchBoxHeading,
            ImpersonationSearchBoxPlaceholder: t.ImpersonationSearchBoxPlaceholder,
            ImpersonationSearchError: t.ImpersonationSearchError,
            IsImpersonatedByText: t.IsImpersonatedByText,
            MultiSelectOneOptionSelectedText: t.MultiSelectOneOptionSelectedText,
            MultiSelectMoreThanOneOptionSelectedText: t.MultiSelectMoreThanOneOptionSelectedText,
            MultiSelectLoadingOptionsText: t.MultiSelectLoadingOptionsText,
            MultiSelectLoadingMoreOptionsText: t.MultiSelectLoadingMoreOptionsText,
            MultiSelectNeedMoreCharactersToSearchText: t.MultiSelectNeedMoreCharactersToSearchText,
            MultiSelectNoOptions: t.MultiSelectNoOptions,
            MultiSelectNoSearchResultsText: t.MultiSelectNoSearchResultsText,
            MyDocumentsLinkText: t.MyDocumentsLinkText,
            MyProfileLinkText: t.MyProfileLinkText,
            MyCasesLinkText: t.MyCasesLinkText,
            NewPasswordHeading: t.NewPasswordHeading,
            NotificationsHeading: t.NotificationsHeading,
            NotificationsNoNotifications: t.NotificationsNoNotifications,
            PasswordRequirementsHeading: t.PasswordRequirementsHeading,
            RepeatNewPasswordHeading: t.RepeatNewPasswordHeading,
            SessionErrorModalButton: t.SessionErrorModalButton,
            SessionErrorModalHeading: t.SessionErrorModalHeading,
            SessionErrorModalText: t.SessionErrorModalText,
            SessionExpirationWarningButton: t.SessionExpirationWarningButton,
            SessionExpirationWarningHeading: t.SessionExpirationWarningHeading,
            SessionExpirationWarningText: t.SessionExpirationWarningText,
            SessionExpiredModalHeading: t.SessionExpiredModalHeading,
            SessionExpiredModalText: t.SessionExpiredModalText,
            SessionInvalidatedModalHeading: t.SessionInvalidatedModalHeading,
            SessionInvalidatedModalText: t.SessionInvalidatedModalText,
            SessionSignedOutModalHeading: t.SessionSignedOutModalHeading,
            SessionSignedOutModalText: t.SessionSignedOutModalText,
            SignInLinkText: t.SignInLinkText,
            SignOutLinkText: t.SignOutLinkText,
            TermsOfService: t.TermsOfService,
            TermsOfServiceLink: t.TermsOfServiceLink,
            Today: t.Today,
            UserToImpersonateHeading: t.UserToImpersonateHeading,
            Yesterday: t.Yesterday,
        };
    }

    get() {
        return { common: this.common, internal: this.internal };
    }
}

